import manageInvitationDialogue from './manage-invitation-dialogue.json';

export default { manageInvitationDialogue };
